import React, { useState } from "react"

const TransferenciasForm = () => {
  return <div></div>
}

export default TransferenciasForm
